import React, { Suspense } from "react";
import {
  Redirect,
  Route,
  BrowserRouter as Router,
  Switch,
} from "react-router-dom";
import "./assets/styles/framework.scss";

import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import "primereact/resources/primereact.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "react-toastify/dist/ReactToastify.css";
import "textcrafter/dist/styles.min.css";

import NoMatch from "./components/NoMatch/NoMatch";

import ProtectedLayout from "./components/ProtectedLayout";
import SellerDashboardLayout from "./components/SellerLayout";
import AuthLayout from "./components/auth/AuthLayout";
import SellerLayout from "./components/seller/SellerLayout";

import { adminDashboardRoutes } from "./routes/AdminDashboardRoutes";
import { authAdminRoutes } from "./routes/AuthAdminRoutes";
import { authSellerRoutes } from "./routes/AuthSellerRoutes";
import { DHEUAdminDashboardRoutes } from "./routes/DHEUAdminDashboardRoutes";
import { printRoutes } from "./routes/PrintRoutes";
import { sellerDashboardRoutes } from "./routes/SellerDashboardRoutes";
import FullSaraLoader from "./components/shared/loader_sara_full/FullSaraLoader";

function App() {
  return (
    <React.Fragment>
      <Router>
        <Suspense fallback={<FullSaraLoader />}>
          <Switch>
            <Route exact path="/">
              <Redirect to="/SellerLogin" />
            </Route>

            {/* ---------------- Admin Auth Start ------------ */}
            {authAdminRoutes.map((route, idx) => (
              <AuthLayout
                key={route.path || route.name || idx}
                path={route.path}
                component={route.component}
              />
            ))}
            {/* ---------------- Admin Auth End ------------ */}

            {/* ---------------- Seller Auth Start ------------ */}
            {authSellerRoutes.map((route, idx) => (
              <SellerLayout
                key={route.path || route.name || idx}
                path={route.path}
                component={route.component}
              />
            ))}
            {/* ---------------- Seller Auth End ------------ */}

            {/* ---------------- Seller Start ------------ */}
            {sellerDashboardRoutes.map((route, idx) => (
              <SellerDashboardLayout
                key={route.path || route.name || idx}
                path={route.path}
                component={route.component}
              />
            ))}
            {/* ---------------- Seller End ------------ */}

            {/* ---------------- Admin Start ------------ */}
            {adminDashboardRoutes.map((route, idx) => (
              <ProtectedLayout
                key={route.path || route.name || idx}
                path={route.path}
                component={route.component}
              />
            ))}
            {/* ---------------- Admin End ------------ */}

            {/* ---------------- Print Start ------------ */}
            {printRoutes.map((route, idx) => (
              <ProtectedLayout
                key={route.path || route.name || idx}
                path={route.path}
                component={route.component}
              />
            ))}
            {/* ---------------- Print End ------------ */}

            {/* ---------------- DHEU Admin Start ------------ */}
            {DHEUAdminDashboardRoutes.map((route, idx) => (
              <ProtectedLayout
                key={route.path || route.name || idx}
                path={route.path}
                component={route.component}
              />
            ))}
            {/* ---------------- DHEU Admin End ------------ */}

            <Route path="*">
              <NoMatch />
            </Route>
          </Switch>
        </Suspense>
      </Router>
    </React.Fragment>
  );
}

export default App;
